import type { CommsMailbox } from "@/server/services/commsInbox"

const LEGACY_COMMS_MAILBOX: Record<string, CommsMailbox> = {
    mail: "inbox",
    messages: "sms",
    phone: "call",
}

export const isLegacyCommsWindowType = (type: string): boolean =>
    type in LEGACY_COMMS_MAILBOX

export const commsDataFromLegacyWindow = ({
    type,
    data,
}: {
    type: string
    data: Record<string, unknown> | undefined
}): Record<string, unknown> => {
    const threadRef =
        typeof data?.threadId === "string"
            ? data.threadId
            : typeof data?.callId === "string"
              ? data.callId
              : undefined
    const docId =
        typeof data?.filterByShipmentDocId === "string"
            ? data.filterByShipmentDocId
            : undefined
    return {
        mailbox: LEGACY_COMMS_MAILBOX[type] ?? "inbox",
        ...(threadRef && { threadRef }),
        ...(docId && { docId }),
    }
}
